import { blueGrey, grey, lightBlue, orange, red, teal } from '@mui/material/colors';
import { experimental_extendTheme as extendTheme, PaletteColorOptions, PaletteColor } from '@mui/material/styles';

import { appBarThemeDefinition, buttonThemeDefinition, tooltipThemeDefinition } from './components';
import { tabsThemeDefinition } from './components/tabsThemeDefinition';

declare module '@mui/material/styles' {
  interface Border {
    main: string;
    light: string;
  }

  interface PaletteOptions {
    border: Border;
    modifyGrey: PaletteColorOptions;
  }

  interface Palette {
    border: Border;
    modifyGrey: PaletteColor;
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    modifyGrey: true;
  }
}

const fontFamily = "'Roboto', 'Helvetica', 'Arial', sans-serif";
const themeExtended = extendTheme({
  typography: { fontFamily: fontFamily },
  colorSchemes: {
    light: {
      palette: {
        primary: {
          light: teal['200'],
          main: teal['500'],
          dark: teal['900'],
        },

        secondary: {
          light: lightBlue['200'],
          main: lightBlue['700'],
          dark: lightBlue['900'],
        },

        error: {
          light: red['500'],
          main: '#d32f2f',
          dark: red['700'],
        },

        modifyGrey: {
          light: grey['200'],
          main: grey['A700'],
          dark: grey['600'],
        },

        warning: {
          main: orange['400'],
        },

        text: {
          primary: blueGrey['800'],
          secondary: blueGrey['500'],
        },

        border: {
          light: '#EEEEEE',
          main: blueGrey['100'],
        },

        common: {
          white: '#FFFFFF',
          black: '#37474f',
        },
      },
    },
  },
  components: {
    ...appBarThemeDefinition(),
    ...buttonThemeDefinition(),
    ...tabsThemeDefinition(),
    ...tooltipThemeDefinition(),
  },
});

export const theme = themeExtended;

export type AppTheme = typeof theme;
